import {
  login,
  logout
} from '@/api'
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'
import {
  resetRouter
} from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: localStorage.getItem('userName') ? localStorage.getItem('userName') : '',
    avatar: '',
    seqId: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ID: (state, id) => {
    state.seqId = id
  }
}

const actions = {
  // user login
  login({
    commit
  }, userInfo) {
    const {
      username,
      password,
      code,
      key
    } = userInfo
    return new Promise((resolve, reject) => {
      console.log(userInfo,'userInfo');
      login({
        username: username.trim(),
        password: password,
        verifycode:code,
        codeKey:key
        })
        .then((response) => {
          // const token = response.data
          // commit('SET_TOKEN', token)
          // commit('SET_NAME', response.data.user.userName)
          // commit('SET_AVATAR', response.data.user.avatarUrl)
          // commit('SET_ID', response.data.user.userId)
          localStorage.setItem('token', response.data.token)
          localStorage.setItem("userInfo", JSON.stringify(response.data.userInfo));
          // localStorage.setItem('account', response.account)
          // localStorage.setItem('userName',response.data.user.userName)
          // localStorage.setItem('userId',response.data.user.userId)
          // localStorage.setItem('roleNum',response.data.user.roleNum)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // user logout
  logout({
    commit
  }) {
    return new Promise((resolve, reject) => {
      logout({
          account: localStorage.getItem('account')
        })
        .then((response) => {
          // removeToken() // must remove  token  first
          localStorage.clear()
          // resetRouter()
          // commit('RESET_STATE')
          resolve()
        })
        .catch((error) => {
          reject(error)
        })

    })
  },

  // remove token
  resetToken({
    commit
  }) {
    return new Promise((resolve) => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}